export default __webpack_public_path__ + "static/media/football.cc567c6c.jpg";